import { faq, pricing, site } from '@/content/site';

const LOW_PRICE = Math.min(...pricing.plans.map((p) => p.monthlyPriceUsd));
const HIGH_PRICE = Math.max(...pricing.plans.map((p) => p.monthlyPriceUsd));

export function SeoJsonLd() {
  const softwareApp = {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: site.brand,
    applicationCategory: 'BusinessApplication',
    operatingSystem: 'Web',
    offers: {
      '@type': 'AggregateOffer',
      lowPrice: String(LOW_PRICE),
      highPrice: String(HIGH_PRICE),
      priceCurrency: 'USD',
    },
  };

  const faqPage = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faq.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.a,
      },
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(softwareApp) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqPage) }}
      />
    </>
  );
}
